import {useTranslationContext} from 'platform/components';

import type {EagColumn} from '../../../../../../types/EagColumn';

export type RevealColumnButtonProps = {
  column: EagColumn;
  /** Scrolls the data grid to this column (un-hiding it first if needed). */
  onReveal: (key: string) => void;
};

/** "Jump to column" icon: an arrow running into a column edge. */
function JumpToColumnIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="3" y1="12" x2="15" y2="12" />
        <polyline points="10 7 15 12 10 17" />
        <line x1="20" y1="5" x2="20" y2="19" />
      </g>
    </svg>
  );
}

/**
 * Per-row "scroll to column" action: scrolls the data grid horizontally to the
 * column and flashes it (utils/scrollToColumn). Rendered on every row — shown
 * and hidden — whenever the panel has the grid's table element.
 */
export function RevealColumnButton(props: RevealColumnButtonProps) {
  const t = useTranslationContext();

  return (
    <button
      type="button"
      className="border-0 bg-transparent cursor-pointer flex rounded-[6px] flex-shrink-0 hover:bg-[#EBECF0] hover:text-[#091E42]"
      style={{color: '#7A869A', padding: '3px'}}
      aria-label={t('page.datagrid.labels.revealColumnAria', {column: props.column.headerName})}
      title={t('page.datagrid.labels.revealColumnAria', {column: props.column.headerName})}
      onClick={() => props.onReveal(props.column.key)}
      data-testid={`columns-panel-reveal-${props.column.key}`}
    >
      <JumpToColumnIcon />
    </button>
  );
}
